import React from 'react'
import PropTypes from 'prop-types'

export default class HoverButton extends React.Component {
  static propTypes = {
    style: PropTypes.object.isRequired,
    hoverStyle: PropTypes.object.isRequired
  }

  state = {
    hover: false
  }

  render() {
    const { children, style, hoverStyle, ...props } = this.props
    const { hover } = this.state

    return (
      <a
        onMouseOver={() => this.setState({ hover: true })}
        onMouseOut={() => this.setState({ hover: false })}
        style={hover ? hoverStyle : style}
        {...props}
      >
        { children }
      </a>
    )
  }
}
